import axios from 'axios';
import { API_URL } from '../const/api';

const axiosInstance = axios.create({
  baseURL: API_URL, 
});

axiosInstance.interceptors.request.use(
  (config) => {
    console.log('Headers solicitud:', config.headers);
    return config;
  },
  (error) => {
    console.error('Error solicitud:', error);
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    console.log('Headers res:', response.headers);
    return response;
  },
  (error) => {
    console.error('Error res:', error);
    return Promise.reject(error);
  }
);

export default axiosInstance;
